import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Brand, BrandService } from '../../../shared/services/brand.service';

const BRAND_NAMES: Record<Brand, string> = { robuschi: 'Robuschi', pedrogil: 'Pedro Gil' };

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit, OnDestroy {
  private readonly brandService = inject(BrandService);
  private readonly cdr = inject(ChangeDetectorRef);
  private brandSub: Subscription | null = null;

  currentYear = new Date().getFullYear();
  companyName = BRAND_NAMES[this.brandService.current];
  version = '1.0.0';

  ngOnInit(): void {
    this.brandSub = this.brandService.brand$.subscribe((brand) => {
      this.companyName = BRAND_NAMES[brand];
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.brandSub?.unsubscribe();
  }
}
